<template>
    <div class="mb-4">
      <div class="mt-5 flow-root border">
        <div class="overflow-x-auto">
          <div class="inline-block min-w-full pt-2 align-middle">
            <table class="min-w-full divide-y divide-gray-200">
              <thead>
              <tr>
                <th scope="col" class="py-3.5 pr-3 pl-4 text-left text-sm font-semibold text-gray-900">ID</th>
                <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">Type/Date</th>
                <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">Team</th>
                <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">Total QTY</th>
                <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">Status</th>
                <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">Created at</th>
                <th scope="col" class="w-20 px-3 py-3.5 text-left text-sm font-semibold text-gray-900" />
              </tr>
              </thead>
              <tbody class="divide-y divide-gray-100 bg-white">
              <tr v-if="deliveryNotes && deliveryNotes.length === 0">
                <td colspan="7" class="py-3 pr-3 pl-4 text-sm font-medium whitespace-nowrap text-gray-400 text-center">
                  No Dispatch note found
                </td>
              </tr>
              <tr
                v-for="(note, i) in deliveryNotes"
                :key="'note-'+note.id" class="relative transition ease-in-out hover:bg-gray-50 group"
                :class="{'bg-red-50': note.status === 'void'}"
              >
                <td class="py-3 pr-3 pl-4 text-sm font-medium whitespace-nowrap text-gray-900">
                  <a
                    target="_blank"
                    :href="note.type === 'collection' ? route('dispatches.handover-list', {note_id: note.id, subView: note.id, status: note.status}) : route('dispatches.delivery', {note_id: note.id, subView: note.id, status: note.status})"
                    class="text-blue-500 hover:underline px-3 py-2"
                  >
                    #{{ note.order_id}}-{{ note.id }}
                  </a>
                </td>
                <td class="px-3 py-4 text-sm whitespace-nowrap text-gray-500">
                  {{ note.type === 'collection' ? 'Collection by Customer' : 'To Be Delivered' }}<br />
                  {{ note.delivery_date | localDate }}
                </td>
                <td class="px-3 py-4 text-sm text-gray-500">
                  <span v-if="note.type === 'delivery' && note.team_id">
                    {{ note.team.name }}
                  </span>
                  <template v-else-if="note.type === 'collection'">
                    Customer
                  </template>
                  <template v-else>
                    N/A
                  </template>
                </td>
                <td class="px-3 py-4 text-sm text-gray-500">
                  {{ getTotalQuantities(note.items) }}
                </td>
                <td class="px-3 py-4 text-sm whitespace-nowrap text-gray-500">
                  {{ note.status}}
                </td>
                <td class="px-3 py-4 text-sm text-gray-500">
                  {{ note.created_at }}
                </td>
                <td class="px-1 py-4 text-sm whitespace-nowrap text-gray-500">
                  <div class="flex items-center gap-x-2">
                    <SplitDeliveryNoteModal
                      v-if="canAdmin('split-dispatch-notes') && note.status !== 'void' && note.status !== 'completed' && (order.status === 'invoiced' || order.status === 'delivery_in_progress')"
                      v-slot="{open}"
                      :note="note"
                      :warehouses="warehouseList"
                      :vessels="vessels"
                      :vessel-locations="vesselLocations"
                      :locations="locations"
                      :order="order"
                      :getWarehouseListFor="getWarehouseListFor"
                    >
                      <button
                        type="button"
                        class="btn-primary px-3 py-2"
                        @click="open"
                      >
                        Split
                      </button>
                    </SplitDeliveryNoteModal>
                    <EditDeliveryNoteModal
                      :note="note"
                      v-slot="{open}"
                      :items="order.items"
                      :warehouse-list="warehouseList"
                      :getWarehouseListFor="getWarehouseListFor"
                      :vessel-locations="vesselLocations"
                      :locations="locations"
                      :key="`view-delivery-note-${note.id}`"
                      readonly
                      :order="order"
                    >
                      <button type="button" class="btn-primary px-3 py-2" @click="open">
                        View <span class="sr-only">{{ note.id }}</span>
                      </button>
                    </EditDeliveryNoteModal>
                    <EditDeliveryNoteModal
                      v-if="canAdmin('update-dispatch-notes') && note.status !== 'void' && note.status !== 'completed' && (order.status === 'invoiced' || order.status === 'delivery_in_progress')"
                      v-slot="{open}"
                      :note="note"
                      :vessel-locations="vesselLocations"
                      :warehouse-list="warehouseList"
                      :get-warehouse-list-for="getWarehouseListFor"
                      :locations="locations"
                      :key="'edit-delivery-note-'+note.id"
                      :order="order"
                    >
                      <button
                        type="button"
                        class="btn-primary px-3 py-2"
                        @click="open"
                        :disabled="!canAdmin('update-dispatch-notes') && isLocked"
                      >
                        Edit
                      </button>
                    </EditDeliveryNoteModal>
                  </div>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
</template>
<script>
import CreateDeliveryNoteModal from "./CreateDeliveryNoteModal.vue";
import Badge from "../../../../../Shared/Badge.vue";
import Icon from "../../../../../Shared/Icon.vue";
import SplitDeliveryNoteModal from "./SplitDeliveryNoteModal.vue";
import AssignTeamModal from "../../../DeliveryNote/AssignTeamModal.vue";
import EditDeliveryNoteModal from "./EditDeliveryNoteModal.vue";

export default {
  name: 'DeliveryNotes',
  components: {EditDeliveryNoteModal, AssignTeamModal, SplitDeliveryNoteModal, Icon, Badge, CreateDeliveryNoteModal},

  props: {
    deliveryNotes: Array,
    warehouseList: Array,
    order: Object,
    getWarehouseListFor: Function,
    vesselLocations: Object,
    locations: Object,
    vessels: Array,
    isLocked: Boolean,
  },

  data() {
    return {
      active: null,
    }
  },

  computed: {
    warehouse() {
      return id => {
        let item = this.warehouseList.find(itm => itm.id === id)
        if (item) {
          return item.name
        }
        return id
      }
    },
  },

  methods: {
    toggle(noteId) {
      if (this.active && this.active === noteId) {
        this.active = null
      } else {
        this.active = noteId
      }
    },

    getTotalQuantities(items) {
      let total = 0
      if (Array.isArray(items) && items.length) {
        items.forEach(itm => total+= itm.quantity_assigned)
      }
      return total
    }
  }
}
</script>
